<template>
  <div>
    <v-data-table
      id="tabela_listaGrupos"
      :key="tableKey"
      :headers="headers"
      :items="listaGruposRepresentacao"
      :options.sync="pagination"
      :server-items-length="totalPage"
      :no-data-text="$t('label.tabela_representacao_conjunto_sem_registro_ativo')"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50],
      }">
      <template v-slot:item.nome_grupo="{ item }">
        {{item.nomeGrupo}}
      </template>
      <template v-slot:item.ind_ativo="{ item }">
        {{ item.indAtivo ? $t('label.ativo') : $t('label.inativo')}}
      </template>
      <template v-slot:item.nome_representantes_legais="{ item }">
        {{item.nomeRepresentantesLegais}}
      </template>
    </v-data-table>
  </div>
</template>
<script>

export default {
  name: 'UsuarioFormGrupoRepConjunto',
  components: {
  },
  props: {
    idGrupoFornecedor: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      representacaoConjuntoResource: this.$api.representacaoConjunto(this.$resource),
      listaGruposRepresentacao: [],
      headers: [
        { text: this.$tc('label.nome_grupo', 1), value: 'nome_grupo', sortable: true },
        { text: this.$tc('label.status', 1), value: 'ind_ativo', sortable: true },
        { text: this.$tc('label.representante_legal_grupo', 2), value: 'nome_representantes_legais', sortable: true },
      ],
      pagination: {},
      lastPagination: {},
      totalPage: 0,
      tableKey: 0,
    };
  },
  computed: {
  },
  watch: {
    idGrupoFornecedor() {
      if (this.idGrupoFornecedor !== null) {
        this.buscarGruposRepresentacao();
      } else {
        this.listaGruposRepresentacao = [];
        this.atualizaTabela();
      }
    },
    pagination: {
      handler() {
        if (this.mesmaPagina(this.pagination, this.lastPagination)
          && !this.mudouOrdenacao(this.pagination, this.lastPagination)) {
          return;
        }
        this.lastPagination = this.pagination;

        this.buscarGruposRepresentacao();
      },
      deep: true,
    },
  },
  methods: {
    mesmaPagina(p1, p2) {
      return p1.page === p2.page && p1.itemsPerPage === p2.itemsPerPage;
    },
    mudouOrdenacao(p1, p2) {
      return p1.sortBy.length !== p2.sortBy.length
        || p1.sortBy[0] !== p2.sortBy[0] || p1.sortDesc[0] !== p2.sortDesc[0];
    },
    atualizaTabela() {
      this.tableKey += 1;
    },
    buscarGruposRepresentacao() {
      const params = {
        idGrupoFornecedor: this.idGrupoFornecedor,
        indAtivo: true,
        indSuspenso: false,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
      };

      if (['nome_grupo', 'nome_representantes_legais'].includes(this.pagination.sortBy[0])) {
        params.colunaOrdenacao = 'lower('.concat(this.pagination.sortBy[0]).concat(')');
      } else {
        const [ordenacao] = this.pagination.sortBy;
        params.colunaOrdenacao = ordenacao;
      }

      this.representacaoConjuntoResource.buscarGruposRepresentacao(params).then((response) => {
        this.listaGruposRepresentacao = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.atualizaTabela();
      }, (err) => {
        this.$error(this, err);
      });
    },
  },
  mounted() {
    this.buscarGruposRepresentacao();
  },
};
</script>
